export enum MapShapeImporter {
    //CSV = 0,
    //Excel = 1,
    ShapeFile = 2,
    MapInfo = 3,
    //FileGDB = 4
}